$ = require('jquery')

require('../class/jquery.fancybox')

module.exports =
	init: (payload) ->
		{$target} = payload

		$target.find('.fancybox').fancybox(
			maxWidth: 1400
			maxHeight: 1000
			padding: 20
			tpl:
				next: '<a class="fancybox-nav fancybox-next" href="javascript:;"><span class="icon icon--arrow-bread"></span></a>'
				prev: '<a class="fancybox-nav fancybox-prev" href="javascript:;"><span class="icon icon--arrow-bread-left"></span></a>'
				closeBtn: '<a class="fancybox-item fancybox-close" href="javascript:;"><span class="icon icon--remove"></span></a>'
		)

		$target.find('.fancybox__form').each(->
			$this = $(this)

			$this.fancybox(
				type: 'ajax'
				width: if $this.hasClass('fancybox__form--small') then 400 else 800
				height: 'auto'
				autoSize: false
				padding: 0
				tpl:
					closeBtn: '<a class="fancybox-item fancybox-close fancybox-close--dark" href="javascript:;"><span class="icon icon--remove"></span></a>'
			)
		)

		return



// WEBPACK FOOTER //
// ./src/js/components/fancybox.coffee